import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  NgZone,
  OnDestroy,
  OnInit,
  Output,
  QueryList,
  TemplateRef,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { NbDialogRef, NbDialogService } from '@nebular/theme';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CalendarView } from 'angular-calendar';
import dayjs from 'dayjs';
import { NgxSpinnerService } from 'ngx-spinner';
import { takeUntil } from 'rxjs';
import { AnalyticsService } from '../../@core/utils';
import { CalendarViewTypes, PacingPlanReasons } from '../../config/calendar-view';
import { ACCELERATION_EVENT, HOLIDAY_EVENT, PUPIL_EVENT, UNASSIGNED_EVENT } from '../../config/events';
import { DummyUserIds } from '../../enum/dummy-user';
import { ROLES, ROLEVALUES, UserRoles } from '../../enum/roles.enum';
import { ClearObservableHelper } from '../../helpers/ClearObservableHelper';
import { CalendarDayEvent, LessonPlanEvent, SchoolCalendar } from '../../interface/calendar';
import { User } from '../../interface/user';
import { AuthService } from '../../services/auth.service';
import { CalendarService } from '../../services/calendar.service';
import { LessonPlanService } from '../../services/lesson-plan.service';
import { OpenAIService } from '../../services/open-ai.service';
import { PacingPlanService } from '../../services/pacing-plan.service';
import { StorageService } from '../../services/storage.service';
import { SubjectService } from '../../services/subject.service';
import { TeacherLessonPlanService } from '../../services/teacher-lesson-plan.service';
import { ToasterService } from '../../services/toaster.service';
import { UtilService } from '../../services/util.service';

@Component({
  selector: 'ngx-pacing-plan-day-view',
  templateUrl: './pacing-plan-day-view.component.html',
  styleUrls: ['./pacing-plan-day-view.component.scss'],
})
export class PacingPlanDayViewComponent extends ClearObservableHelper implements OnInit, OnDestroy {
  calendarViewTypes = Object.values(CalendarViewTypes);
  pacingPlanReasons = Object.values(PacingPlanReasons);
  selectedPushLessonPlanEventReason = '';
  lessonPlanForm: FormGroup;
  sectionId: any;
  customSectionId: any;
  @Input() view = '';
  @Input() calendarCurrentDate = '';
  CalendarView = CalendarView;
  public currentDate = new Date();
  @ViewChild('selectSubjectDialog') selectSubjectDialog: TemplateRef<any>;
  @ViewChild('pushLessonPlanDialog') pushLessonPlanDialog: TemplateRef<any>;
  calendarViewType = CalendarView.Day;
  viewDate: Date = new Date();
  activeDayIsOpen: boolean = true;
  currentCalendar: SchoolCalendar[];
  lessonPlanEvents: LessonPlanEvent[] = [];
  @ViewChild('myModal') myModal;
  @ViewChild('pushLessonPlanChoiceModal', { static: false })
  modalElement!: ElementRef;
  @ViewChild('aiLessonPlanModal', { static: false })
  aiModalElement!: ElementRef;
  @ViewChild('lessonPlanModal') lessonPlanModal: TemplateRef<any>;
  @Output() newItemEvent = new EventEmitter<string>();
  pacingPlanEvents: any;
  dayEvent;
  pacingPlanList = [];
  events: CalendarDayEvent[];
  isView = false;
  loadingText = '';
  private dialogRef: NbDialogRef<any>;
  lastpacingPlanDay: Date;
  isStart = false;
  isEnd = false;
  testAndReviewDays = [];
  testAndReviewDay = [];
  isAdd = true;
  isBack = false;
  isShowLessonPlans = false;
  isPush = false;
  @Input() classroom: any;
  @Input() teacherId: number;
  @Input() isExpandModal: boolean;
  @Input() schoolCalendarEvents: SchoolCalendar[];
  @Input() user: User;
  isLoading = false;
  public roles = ROLES;
  currentLessonPlan;
  currentShowPacingPlan = [];
  isNewAdd = false;
  startHour = 0;
  endHour = 24;
  dates = [];
  currentGlobalPacingPlan;
  currentLessonPlanToPush;
  currentPacingPlanIdToPush = 0;
  public standard: string = '';
  databaseEvents: any = [];
  @ViewChildren(CdkTextareaAutosize) autosize: QueryList<CdkTextareaAutosize>;
  userAccessToken: any;
  userAccessAIToken: any;
  currentLocalStorageUser: any;
  manualGlobalEvents;
  public addLessonPlanForm: FormGroup;
  public isCustomStandard: boolean = false;
  deletedDays = [];
  private deletedTestDays;
  private deletedReviewDays;
  isGenerateNew: boolean = false;
  spinnerText = '';
  isTeacherOnly: boolean = false;
  subjectHoursData;
  isEditing = false;
  constructor(
    private storageService: StorageService,
    private calendarService: CalendarService,
    private lessonPlanService: LessonPlanService,
    public modalService: NgbModal,
    private openAIService: OpenAIService,
    public pacingPlanService: PacingPlanService,
    private toasterService: ToasterService,
    private subjectService: SubjectService,
    private dialogService: NbDialogService,
    public dialog: MatDialog,
    private teacherLessonPlanService: TeacherLessonPlanService,
    public router: Router,
    private fb: FormBuilder,
    public analyticsService: AnalyticsService,
    private activatedRoute: ActivatedRoute,
    private sanitizer: DomSanitizer,
    private _ngZone: NgZone,
    private authService: AuthService,
    private spinner: NgxSpinnerService,
    private utilService: UtilService,
  ) {
    super();
  }

  async ngOnInit() {
    try {
      this.getFormControls();
      this.spinner.show('pacingPlanDayViewSpinner');
      this.isTeacherOnly = this.user.role_id === ROLEVALUES.TEACHER_ONLY ? true : false;
      await this.initializeOnInIt();
      // for multi subjects classrooms
      await this.getSubjectHoursData();
      // this.getUserToken();
      this.getUserAIToken();
      this.storageService.removeItem('englishStoryData');

      // Subscribe to calendar changes to update hours dynamically
      this.storageService.setSelectedSchoolsCalendarToLocalStorage
        .pipe(takeUntil(this.destroy$))
        .subscribe(async (res) => {
          if (res) {
            await this.initializeOnInIt();
          }
        });
      this.spinner.hide('pacingPlanDayViewSpinner');
    } catch (error) {
      // console.log(error);
      this.spinner.hide('pacingPlanDayViewSpinner');
    }
  }

  async triggerResize() {
    this._ngZone.onStable.observers = this._ngZone.onStable.observers.splice(0, 1);
    this._ngZone.onStable.pipe().subscribe(() => {
      this.autosize.forEach((el) => {
        el.reset();
        el.resizeToFitContent(true);
      });
    });
  }

  async getAllLessonPlanEvents(subject_id: number, grades_id: number) {
    try {
      const body = {
        user_id: this.user.id,
        school_id: this.user.school_id,
        subject_id: subject_id,
        grades_id: grades_id,
        start_time: new Date(this.viewDate.setHours(0, 0, 0, 0)).getTime(),
        classroom_id: this.classroom.id,
      };
      return await this.lessonPlanService.getTeacherLessonPlanByUserId(body);
    } catch (error) {
      // console.log(error);
    }
  }

  getFormControls(): void {
    this.lessonPlanForm = this.fb.group({
      objective: ['', Validators.required],
      anticipatory_set: ['', Validators.required],
      presentation: ['', Validators.required],
      guided_practice_questions: ['', Validators.required],
      homework_questions: ['', Validators.required],
      closure: ['', Validators.required],
      start: ['', Validators.required],
      end: ['', Validators.required],
    });

    this.addLessonPlanForm = this.fb.group({
      standard_type: [''],
    });
  }

  async initializeOnInIt() {
    try {
      this.pacingPlanService.currentUrl.includes('lesson-plan-view') ||
      this.pacingPlanService.currentUrl.includes('classroom-details')
        ? (this.isBack = true)
        : (this.isBack = false);

      this.calendarService.viewDate ? (this.viewDate = this.calendarService.viewDate) : (this.viewDate = new Date());
      const user = this.storageService.getItem('user');

      this.currentCalendar =
        this.schoolCalendarEvents && this.schoolCalendarEvents.length > 0
          ? this.schoolCalendarEvents
          : ((await this.getSchoolCalendarBySchoolId()) as any[]);

      if (this.user.is_trial_user) {
        await this.setTrialUserSchool();
      }

      const selectedSchoolCalendar = this.storageService.getItem('selectedSchoolCalendarByAdmin');
      await this.setSelectedCalendarToFirst(selectedSchoolCalendar);

      // Initialize hours on page load
      const currentSchool = selectedSchoolCalendar?.school_id || user?.user?.school;

      this.startHour = selectedSchoolCalendar?.extras?.startTime
        ? new Date(selectedSchoolCalendar.extras.startTime).getHours()
        : user?.user?.school?.start_time
          ? new Date(user.user.school.start_time).getHours()
          : this.startHour;

      this.endHour = selectedSchoolCalendar?.extras?.endTime
        ? new Date(selectedSchoolCalendar.extras.endTime).getHours()
        : user?.user?.school?.end_time
          ? new Date(user.user.school.end_time).getHours()
          : this.endHour;

      this.events = await this.updateEventsData();
      await this.getLessonPlanEvents();

      this.isView = true;
      if (this.pacingPlanService?.subject_id !== 0 && this.pacingPlanService?.grades_id !== 0) {
        await this.getGlobalPacingPlanCurrentPacingPLan();
      }
    } catch (error) {
      // console.log(error);
    }
  }

  async setTrialUserSchool() {
    this.currentCalendar[0].start = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
    this.currentCalendar[0].end = this.getLastDayOfMonthOneYearFromNow(new Date());

    await this.setEventsAsCurrentYearEvents();
  }

  async setEventsAsCurrentYearEvents() {
    this.currentCalendar[0].holidays.map((x) => {
      x.end = new Date(x.end).setFullYear(new Date().getFullYear());
      x.start = new Date(x.start).setFullYear(new Date().getFullYear());
    });

    this.currentCalendar[0].acceleration.map((x) => {
      x.end = new Date(x.end).setFullYear(new Date().getFullYear());
      x.start = new Date(x.start).setFullYear(new Date().getFullYear());
    });

    this.currentCalendar[0].pupil_free.map((x) => {
      x.end = new Date(x.end).setFullYear(new Date().getFullYear());
      x.start = new Date(x.start).setFullYear(new Date().getFullYear());
    });

    this.currentCalendar[0].bank_days.map((x) => {
      x.end = new Date(x.end).setFullYear(new Date().getFullYear());
      x.start = new Date(x.start).setFullYear(new Date().getFullYear());
    });

    this.currentCalendar[0].unassigned.map((x) => {
      x.end = new Date(x.end).setFullYear(new Date().getFullYear());
      x.start = new Date(x.start).setFullYear(new Date().getFullYear());
    });
  }

  getLastDayOfMonthOneYearFromNow(currentDate: Date) {
    const nextYear = new Date(currentDate.getFullYear() + 1, currentDate.getMonth(), 1);

    nextYear.setMonth(nextYear.getMonth() + 1);
    nextYear.setDate(0);

    return nextYear;
  }

  async getGlobalLessonPlanByPacingPlanId() {
    try {
      const params = {
        pacing_plan_id: this.currentShowPacingPlan[0].id,
      };

      return await this.lessonPlanService.globalLessonPlanByPacingPlanId(params);
    } catch (error) {
      // console.log(error);
    }
  }

  async getLessonPlanEvents(isLoad = false) {
    try {
      if (isLoad) this.spinner.show('pacingPlanDayViewSpinner');
      const lessonPlanEvents = await this.getLessonPlanByUserId();
      this.lessonPlanEvents = await this.updateEvents(lessonPlanEvents);
      this.lessonPlanEvents = this.lessonPlanEvents.filter((data: any) => {
        return data.lesson_plan.section_id !== '' && data.lesson_plan.section_title !== '';
      });
      if (isLoad) this.spinner.hide('pacingPlanDayViewSpinner');
    } catch (error) {
      // console.log(error);
      if (isLoad) this.spinner.hide('pacingPlanDayViewSpinner');
    }
  }

  //To display multiple standards with section ID
  getPlans(lessonPlan: any): any[] {
    if (!lessonPlan) {
      return [];
    }
    const response = [
      ...(lessonPlan.pacing_plan_id || []),
      ...(lessonPlan.teacher_custom_pacing_plans_id || []),
      ...(lessonPlan.custom_global_pacing_plan ? [lessonPlan.custom_global_pacing_plan] : []),
    ];

    return response.filter((plan) => plan !== null);
  }

  async getGlobalPacingPlanCurrentPacingPLan(isPushed = false) {
    try {
      await this.getGlobalPacingPlanEvents(isPushed ? true : false);
      await this.getCurrentPacingPlanToShow();
    } catch (error) {
      // console.log(error);
    }
  }

  async getGlobalPacingPlanEvents(isPushed = false) {
    try {
      const isInitialPacingPlans = this.storageService.getItem('isInitialLessonPlan');

      if (this.classroom.isManual) {
        this.manualGlobalEvents = await this.pacingPlanService.getCustomEventsAndPacingPlansBySubjectId({
          classroom_id: this.classroom.id,
          subject_id: this.classroom.current_subject_id,
        });
      }

      if (this.pacingPlanService.testAndReviewDays?.length > 0) {
        this.testAndReviewDays = this.pacingPlanService.testAndReviewDays;
      } else {
        await this.getTestAndReviewDays();
      }

      if (
        !isInitialPacingPlans &&
        !isPushed &&
        this.pacingPlanService.pacingPlanEvents &&
        this.pacingPlanService.pacingPlanEvents.length > 0
      ) {
        this.pacingPlanEvents = this.pacingPlanService.pacingPlanEvents;
        this.getDates();
      } else {
        await this.getGlobalPacingPlans();
      }

      if (
        !isInitialPacingPlans &&
        !isPushed &&
        this.pacingPlanService.pacingPlanEvents &&
        this.pacingPlanService.pacingPlanEvents.length > 0
      )
        this.pacingPlanList = [...new Map(this.pacingPlanEvents.map((item) => [item['section_title'], item])).values()];
      if (isPushed) {
        this.pacingPlanService.pacingPlanEvents = this.pacingPlanEvents;
      }
    } catch (error) {
      console.log('getGlobalPacingPlanEvents', error);
    }
  }

  async getGlobalPacingPlans(): Promise<void> {
    try {
      const params = {
        subject_id: this.classroom.current_subject_id,
        grades_id: this.classroom.grades_id,
      };

      this.databaseEvents = this.classroom.isManual
        ? await this.pacingPlanService.getCustomEventsAndPacingPlansBySubjectId({
            subject_id: this.classroom.current_subject_id,
            classroom_id: this.classroom.id,
            grades_id: this.classroom.isManual ? '' : this.classroom.grades_id,
          })
        : await this.pacingPlanService.getGlobalPacingPlanBySubjectAndGradeId(params);
      const body = {
        subject_id: this.classroom.current_subject_id,
        grades_id: this.classroom.grades_id,
        user_id: this.user.id,
        classroom_id: this.classroom.id,
      };

      const customPacingPlanEvents = await this.pacingPlanService.getCustomGlobalPacingPlan(body);
      await this.getTestAndReviewDays();
      await this.getDates();

      if (this.classroom.isManual) {
        this.pacingPlanEvents = this.databaseEvents.manual_pacing_plans.map((x) => {
          if (x.global_pacing_plan_id) {
            // If global_pacing_plan_id exists, modify global_pacing_plan
            return {
              ...x.global_pacing_plan,
              created_at: x.created_at,
              start_date: x.start_date,
              end_date: x.end_date,
            };
          } else {
            // Otherwise, modify teacher_custom_pacing_plans
            return {
              ...x.teacher_custom_pacing_plans,
              created_at: x.created_at,
              start_date: x.start_date,
              end_date: x.end_date,
            };
          }
        });
      } else {
        this.pacingPlanEvents = this.databaseEvents;
      }

      this.pacingPlanEvents = [...this.pacingPlanEvents, ...customPacingPlanEvents];

      await this.setDateToGlobalPacingPlanEvents(this.databaseEvents.manual_pacing_plans);
      await this.updatePacingPlansAsPerPushedPlans();

      this.events = await this.updateEventsData();
    } catch (error) {
      console.log(error);
    }
  }

  async checkDeletedStandardAndUpdate(): Promise<void> {
    const body = {
      user_id: this.user.id,
      grades_id: this.classroom.grades_id,
      subject_id: this.classroom.current_subject_id,
      classroom_id: this.classroom.id,
    };

    const response = await this.pacingPlanService.getDeletedStandardPerClassroomSubject(body);

    if (response && response.length > 0) {
      this.pacingPlanEvents = this.pacingPlanEvents.filter((item: any) => {
        return (
          item.multiple === true ||
          !response.some((deletedItem: any) => {
            return (
              (new Date(deletedItem.date).toDateString() === new Date(item.start || item.start_date).toDateString() &&
                item.id === deletedItem.section_id) ||
              item.multiple === true
            );
          })
        );
      });

      this.pacingPlanEvents = this.pacingPlanEvents.filter((item: any) => {
        return !response.some((deletedItem: any) => {
          return (
            new Date(deletedItem.date).toDateString() === new Date(item.start || item.start_date).toDateString() &&
            item.id === deletedItem.section_id
          );
        });
      });
    }
  }

  // functionality of pushed or custom added pacing plans to the calendar
  async updatePacingPlansAsPerPushedPlans() {
    try {
      let response: any = await this.getTeacherPacingPlans();
      response = response.sort((a: any, b: any) => {
        return a.created_at > b.created_at ? 1 : -1;
      });

      if (response && response.length > 0) {
        for (const iterator of response) {
          // to check if pacing plan is custom added after deletion of standard
          if (iterator.isDeleted) {
            if (iterator?.extras?.isMultiple) {
              await this.customAddedStandards(iterator, true);
            } else {
              await this.customAddedStandards(iterator);
            }
          }
          // if the pacing plan is pushed
          else {
            // forward all the pacing plans from the current date to next dates
            await this.pushPlansToNextDate(iterator);
            if (iterator?.reason === 'Reteach Yesterday’s Standard') {
              await this.reteachYesterdayStandard(iterator);
            } else if (iterator?.reason === 'Reteach Standard of Choice') {
              await this.reteachStandardofChoice(iterator, iterator?.lesson_plan_pacing_id, false);
            } else {
              await this.reteachStandardofChoice(iterator, iterator?.custom_global_pacing_plan_id, true);
            }
          }
        }
      }

      await this.checkDeletedStandardAndUpdate();
    } catch (error) {
      console.log(error);
    }
  }

  // functionality of custom added standard by deleting particular standard
  async customAddedStandards(iterator: any, multiple = false) {
    const globalPacingIndex = this.pacingPlanEvents.findIndex(
      (x: any) => new Date(x.start).toDateString() === new Date(iterator.start).toDateString(),
    );

    if (!multiple && globalPacingIndex !== -1) {
      this.pacingPlanEvents.splice(globalPacingIndex, 1);
    }
    if (iterator.reason && iterator.reason !== '') {
      this.testAndReviewDays.push({
        start: new Date(iterator.start),
        end: new Date(iterator.end),
        isDay: true,
        type: iterator.reason === 'test-day' ? 'Test Day' : 'Review Day',
      });
    } else {
      const newStandard = iterator.pacing_plan ? iterator.pacing_plan : iterator.teacher_custom_pacing_plans;
      newStandard['start'] = iterator.start;
      newStandard['end'] = iterator.end;
      newStandard['subject_id'] = iterator.subject_id;
      newStandard['grades_id'] = iterator.grades_id;
      await this.pushStandardToGlobalEvents(newStandard, multiple);
    }
  }

  // for standard of choice push
  async reteachStandardofChoice(iterator: any, pacingPlanId: any, isCustom?) {
    try {
      if (isCustom) {
        const newStandard = iterator.teacher_custom_pacing_plans
          ? iterator.teacher_custom_pacing_plans
          : iterator.custom_global_pacing_plan;
        newStandard['start'] = iterator.start;
        newStandard['end'] = iterator.end;
        newStandard['subject_id'] = iterator.subject_id;
        newStandard['grades_id'] = iterator.grades_id;
        await this.pushStandardToGlobalEvents(newStandard);
      } else {
        const databaseEvent = this.databaseEvents?.find((x: any) => x.id === pacingPlanId);
        if (databaseEvent) {
          const globalStandardOfChoice = structuredClone(databaseEvent);
          globalStandardOfChoice.start = iterator.start;
          globalStandardOfChoice.end = iterator.end;
          await this.pushStandardToGlobalEvents(globalStandardOfChoice);
        }
      }
    } catch (error) {
      // console.log(error);
    }
  }

  // for yesterday standard push
  async reteachYesterdayStandard(iterator: any) {
    try {
      // get the previous date from pushed plan
      let index = this.dates.findIndex(
        (x: any) => new Date(x.start).toDateString() === new Date(iterator.start).toDateString(),
      );

      if (index !== -1) {
        for (let i = index - 1; i >= 0; i--) {
          if (this.dates[i].addEvent === true) {
            let previousDate = this.dates[i].start;

            this.pacingPlanEvents.map((x: any) => {
              if (new Date(x.start).toDateString() === new Date(previousDate).toDateString()) {
                const data = structuredClone(x);

                data.start = iterator.start;
                data.end = iterator.end;

                this.pacingPlanEvents.push(data);
              }

              return x;
            });
            break;
          }
        }
      }
    } catch (error) {
      console.log(error);
    }
  }

  // add previous standard to current date
  async addPacingPlanToCalendarPerIndex(iterator: any, index: number) {
    const currentPlan = structuredClone(this.pacingPlanEvents[index]);

    currentPlan.start = iterator.start;
    currentPlan.end = iterator.end;
    await this.pushStandardToGlobalEvents(currentPlan);
  }

  // push each pacing plan from date to the next date
  async pushPlansToNextDate(iterator: any) {
    // Filter out the standards from globalPacingPlanEvents that match the iterator condition

    // Filter standards based on the iterator's start and end dates

    let filteredStandards = this.classroom.isManual
      ? this.pacingPlanEvents
          .filter(
            (x: any) =>
              new Date(x.start).getTime() >= new Date(iterator.start).getTime() &&
              new Date(x.end).getTime() >= new Date(iterator.end).getTime() &&
              new Date(x.created_at).getTime() < new Date(iterator.created_at).getTime(),
          )
          .sort((a: any, b: any) => {
            return new Date(a.start).getTime() - new Date(b.start).getTime();
          })
      : this.pacingPlanEvents
          .filter(
            (x: any) =>
              new Date(x.start).getTime() >= new Date(iterator.start).getTime() &&
              new Date(x.end).getTime() >= new Date(iterator.end).getTime(),
          )
          .sort((a: any, b: any) => {
            return new Date(a.start).getTime() - new Date(b.start).getTime();
          });

    // Group the filtered standards by their start date
    const groupedStandards = filteredStandards.reduce((acc: any, event: any) => {
      const dateKey = new Date(event.start).toDateString(); // Grouping by start date
      if (!acc[dateKey]) {
        acc[dateKey] = []; // Create a new group if it doesn't exist
      }
      acc[dateKey].push(event); // Add the event to the group
      return acc;
    }, {});

    this.pacingPlanEvents = this.classroom.isManual
      ? this.pacingPlanEvents.filter(
          (x: any) =>
            (new Date(x.start).getTime() < new Date(iterator.start).getTime() &&
              new Date(x.end).getTime() < new Date(iterator.end).getTime()) ||
            new Date(x.created_at).getTime() > new Date(iterator.created_at).getTime(),
        )
      : this.pacingPlanEvents.filter(
          (x: any) =>
            new Date(x.start).getTime() < new Date(iterator.start).getTime() &&
            new Date(x.end).getTime() < new Date(iterator.end).getTime(),
        );
    // Convert grouped standards into an array of arrays
    const groupedStandardsArray = Object.values(groupedStandards);

    // Iterate through the grouped standards and adjust their start and end dates
    groupedStandardsArray.forEach((x: any) => {
      const index = this.dates.findIndex(
        (date: any) =>
          date.addEvent === true &&
          date.start.getTime() > new Date(x[0].start).setHours(0, 0, 0, 0) &&
          date.end.getTime() >= new Date(x[0].end).setHours(23, 59, 59, 59),
      );

      if (index !== -1) {
        const ele = this.dates[index];
        if (ele) {
          x.forEach((d: any) => {
            d.start = ele.start;
            d.end = ele.end;
          });
        }
      }
    });

    // Flatten grouped standards into single standards and add them to globalPacingPlanEvents
    groupedStandardsArray.forEach((group: any) => {
      group.forEach((standard: any) => {
        this.pacingPlanEvents.push(standard);
      });
    });
  }

  async pushStandardToGlobalEvents(addPushedGlobalPacingPlanEvent: any, multiple?: boolean) {
    if (addPushedGlobalPacingPlanEvent && addPushedGlobalPacingPlanEvent.id) {
      const item = {
        start: addPushedGlobalPacingPlanEvent.start,
        end: addPushedGlobalPacingPlanEvent.end,
        section_id: addPushedGlobalPacingPlanEvent.section_id,
        section_title: addPushedGlobalPacingPlanEvent.section_title,
        grades_id: addPushedGlobalPacingPlanEvent.grades_id,
        subject_id: addPushedGlobalPacingPlanEvent.subject_id,
        id: addPushedGlobalPacingPlanEvent.id,
      };

      if (multiple) {
        item['multiple'] = true;
      }
      this.pacingPlanEvents.push(item);
    }
  }

  async getTeacherPacingPlans() {
    try {
      const teacherPacingPlanBody = {
        subject_id: this.classroom.current_subject_id,
        grades_id: this.classroom.grades_id,
        user_id: this.user.id,
        classroom_id: this.classroom?.id,
      };
      return await this.pacingPlanService.getTeacherPacingPlan(teacherPacingPlanBody);
    } catch (error) {
      // console.log(error);
    }
  }

  async setDateToGlobalPacingPlanEvents(pacingPlanEvents: any) {
    try {
      if (this.classroom.isManual) {
        return this.pacingPlanEvents.map((x, i) => {
          (x.start = new Date(pacingPlanEvents[i].start_date)), (x.end = new Date(pacingPlanEvents[i].end_date));
          return x;
        });
      } else {
        const filteredDates = this.dates.filter((x) => x.addEvent === true);
        return this.pacingPlanEvents.map((x, i) => {
          if (filteredDates[i]) {
            if (x.teacher_custom_pacing_plans_id) {
              x.start = new Date(x.start);
              x.end = new Date(x.end);
            } else {
              x.start = new Date(filteredDates[i].start);
              x.end = new Date(filteredDates[i].end);
            }
            return x;
          }
        });
      }
    } catch (error) {
      // console.log(error);
    }
  }

  async getDates() {
    try {
      this.dates = [];
      const date1 = this.user?.role_id === 19 ? dayjs().startOf('year') : dayjs(this.currentCalendar[0].start);
      const date2 =
        this.user?.role_id === 19 ? dayjs(dayjs().add(1, 'year')).endOf('year') : dayjs(this.currentCalendar[0].end);
      const diff = date2.diff(date1, 'day');
      const calendarStartDate =
        this.user?.role_id === 19
          ? dayjs().startOf('year').add(1, 'day')
          : this.user?.is_trial_user
            ? dayjs(this.currentCalendar[0].start)
            : dayjs(this.currentCalendar[0].start);
      for (let i = 0; i < diff; i++) {
        const startDate: any = dayjs(calendarStartDate).add(i, 'day');

        const date: any = {
          start: dayjs(startDate.startOf('day'), 'YYYY-MM-DD').tz().toDate(),
          end: dayjs(startDate.endOf('day'), 'YYYY-MM-DD').tz().toDate(),
          addEvent: await this.checkIfDateIsValid(startDate),
        };

        this.dates.push(date);
      }
    } catch (error) {
      console.log('getDates', error);
    }
  }

  async getUpdatedDates() {
    try {
      const dates = [];
      const date1 = this.user?.role_id === 19 ? dayjs().startOf('year') : dayjs(this.currentCalendar[0].start);
      const date2 =
        this.user?.role_id === 19 ? dayjs(dayjs().add(1, 'year')).endOf('year') : dayjs(this.currentCalendar[0].end);
      const diff = date2.diff(date1, 'day');
      const calendarStartDate =
        this.user?.role_id === 19
          ? dayjs().startOf('year').add(1, 'day')
          : this.user?.is_trial_user
            ? dayjs(this.currentCalendar[0].start)
            : dayjs(this.currentCalendar[0].start);
      for (let i = 0; i < diff; i++) {
        const startDate: any = dayjs(calendarStartDate).add(i, 'day');

        const date: any = {
          start: dayjs(startDate.startOf('day'), 'YYYY-MM-DD').tz().toDate(),
          end: dayjs(startDate.endOf('day'), 'YYYY-MM-DD').tz().toDate(),
          addEvent: await this.checkIfDateIsValid(startDate),
        };
        if (date.addEvent === true) dates.push(date);
      }

      return dates;
    } catch (error) {
      //console.log(error);
    }
  }

  async checkIfDateIsValid(startDate: any) {
    try {
      if (startDate.day() === 0 || startDate.day() === 6) {
        return false;
      }

      const d = this.checkIfDeletedTestAndReviewDay(new Date(startDate.$d.setHours(0, 0, 0, 0)));

      if (d !== undefined) {
        const removalDay = this.testAndReviewDays.find((x) => x.start.toDateString() === startDate.$d.toDateString());
        if (removalDay) {
          this.testAndReviewDays.splice(this.testAndReviewDays.indexOf(removalDay), 1);
        }
        return d;
      }

      const ifCurrentDateIsTestAndReviewDay = await this.ifDayIsTestOrReviewDay(
        new Date(startDate.$d.setHours(0, 0, 0, 0)),
      );

      if (ifCurrentDateIsTestAndReviewDay && ifCurrentDateIsTestAndReviewDay.length > 0) {
        return false;
      }

      if (this.checkIfDateIsEventDate(startDate?.$d)) {
        return false;
      }

      if (this.checkIfPresentInExtraEvents(startDate)) {
        return true;
      }

      return false;
    } catch (error) {
      // console.log(error)
    }
  }

  checkIfDeletedTestAndReviewDay(date: any) {
    if (this.deletedDays.length === 0) {
      return;
    }

    const res = this.deletedDays.find((x) => new Date(x.start).toDateString() === new Date(date).toDateString());

    if (!res) {
      return;
    }

    return res.added_event ? true : false;
  }

  checkIfDateIsEventDate(date: Date) {
    try {
      return this.events.some(
        (x) =>
          date.setHours(0, 0, 0, 0) >= new Date(x.start).setHours(0, 0, 0, 0) &&
          date.getTime() <= new Date(x.end).setHours(23, 59, 59, 59),
      );
    } catch (error) {
      // console.log(error);
    }
  }

  async getCurrentPacingPlanToShow() {
    try {
      if (this.viewDate.getDay() === 6 || this.viewDate.getDay() === 0) {
        this.isShowLessonPlans = false;
        this.currentShowPacingPlan = [];
        this.testAndReviewDay = [];
      } else {
        this.isShowLessonPlans = true;
        this.currentShowPacingPlan = await this.getPacingPlanByUserIdandSubject();
        this.isStart = this.viewDate.getTime() === new Date(this.currentCalendar[0].start).getTime();
        this.isEnd = this.viewDate.getTime() === new Date(this.currentCalendar[0].end).getTime();
        this.testAndReviewDay = await this.ifDayIsTestOrReviewDay();
      }
    } catch (error) {
      // console.log(error);
    }
  }

  // ngAfterContentChecked(): void {
  //   this.changeDetector.detectChanges();
  // }

  async updateEventsData() {
    try {
      const events = [];
      this.currentCalendar[0].holidays.map((event) =>
        events.push({
          start: new Date(event.start),
          end: new Date(event.end),
          title: event.title,
          cssClass: HOLIDAY_EVENT[0].cssClass,
        }),
      ),
        this.currentCalendar[0].pupil_free.map((event) =>
          events.push({
            start: new Date(event.start),
            end: new Date(event.end),
            title: event.title,
            cssClass: PUPIL_EVENT[0].cssClass,
          }),
        ),
        this.currentCalendar[0].acceleration.map((event) =>
          events.push({
            start: new Date(event.start),
            end: new Date(event.end),
            title: event.title,
            cssClass: ACCELERATION_EVENT[0].cssClass,
          }),
        );

      this.currentCalendar[0].unassigned.map((event) =>
        events.push({
          start: new Date(event.start),
          end: new Date(event.end),
          title: event.title,
          cssClass: UNASSIGNED_EVENT[0].cssClass,
        }),
      );

      return events;
    } catch (error) {
      // console.log(error);
    }
  }

  beforeDayViewRender(event) {
    const pacingPlan =
      this.pacingPlanEvents && this.pacingPlanEvents.length > 0
        ? this.pacingPlanEvents.filter((x) => new Date(x.start).toDateString() === event.header[0].date.toDateString())
        : [];
    const calendarEvent =
      this.events && this.events.length > 0
        ? this.events.filter(
            (x) =>
              new Date(x.start).toDateString() === event?.header[0]?.date.toDateString() ||
              new Date(x.end).toDateString() === event?.header[0]?.date.toDateString() ||
              (event?.header[0]?.date.getTime() >= new Date(x.start).getTime() &&
                event?.header[0]?.date.getTime() <= new Date(x.end).getTime()),
          )
        : [];

    pacingPlan && pacingPlan.length > 0
      ? (event.header[0]['pacingPlan'] = pacingPlan[0])
      : (event.header[0]['calendarEvent'] = calendarEvent[0]);
    if (pacingPlan && pacingPlan.length > 0) {
      this.dayEvent = pacingPlan[0];
    } else {
      this.dayEvent = calendarEvent[0];
    }
  }

  async getPacingPlanByUserIdandSubject() {
    try {
      return this.pacingPlanEvents.filter(
        (x: any) => new Date(x.start).toDateString() === this.viewDate.toDateString(),
      );
    } catch (error) {
      // console.log(error);
    }
  }

  async lessonPlanEventClicked(pacingPlanId: number, isCustomStandard?: boolean, isAddNew?: boolean) {
    try {
      this.analyticsService?.trackEvent('Add Lesson Plan Events', 'Pacing Plan Day View');

      this.spinner.show('pacingPlanDayViewSpinner');
      this.isGenerateNew = isAddNew;
      const subjectHoursBody = {
        user_id: this.classroom.user_id ? this.classroom.user_id : this.user.id,
        subject_id: pacingPlanId
          ? isCustomStandard
            ? this.customSectionId.subject_id
            : this.sectionId?.subject_id
          : this.classroom.current_subject_id,
        grade_id: pacingPlanId
          ? isCustomStandard
            ? this.customSectionId.grades_id
            : this.sectionId?.grades_id
          : this.classroom.grades_id,
        day: this.utilService.getWeekDayString(this.viewDate.getDay()).toLowerCase(),
      };
      if (this.user?.teachingInfo?.schoolBellScheduleId && this.classroom.user_id === this.user.id)
        subjectHoursBody['school_bell_shedules_id'] = this.user?.teachingInfo?.schoolBellScheduleId;

      if (this.user.is_trial_user) {
        // Set the dummy teacher ID to fetch the subject hours
        subjectHoursBody['user_id'] = this.user?.teachingInfo?.dummyUserId ?? DummyUserIds.TEACHER;
      }

      let subjectHours: any = [];

      if (this.classroom?.extras['eventDates']?.length > 0) {
        subjectHours = this.classroom.extras['eventDates'].filter(
          (x) =>
            x.day === this.utilService.getWeekDayString(this.viewDate.getDay()).toLowerCase() &&
            (x.subject_id ? this.classroom.current_subject_id === x.subject_id : true),
        );
      }

      if (subjectHours?.length === 0) {
        subjectHours = await this.teacherLessonPlanService.getTeacherSubjectHours(
          subjectHoursBody,
          this.user?.is_trial_user ? true : false,
        );
      }
      if ((subjectHours && subjectHours.length > 0) || this.user.role_id === ROLES.SUPER_ADMIN) {
        let typeOfLessonPlan;
        if (pacingPlanId && pacingPlanId !== undefined) {
          const adminLessonPlan = await this.getAdminLessonPlan(pacingPlanId);
          if (adminLessonPlan && adminLessonPlan.length > 0 && adminLessonPlan[0] !== undefined) {
            this.emitFalseValueToDismissBottomSheet();
            this.storageService.setItem('currentValidDates', await this.getUpdatedDates());
            this.storageService.removeItem('lessonPlanIdType');
            typeOfLessonPlan = adminLessonPlan[0]['pacing_plan_id']
              ? 'pacing_plan_id'
              : adminLessonPlan[0]['teacher_custom_pacing_plans_id']
                ? 'teacher_custom_pacing_plans_id'
                : 'custom_global_pacing_plan_id';
            this.storageService.setItem('lessonPlanIdType', typeOfLessonPlan);
            pacingPlanId
              ? this.router.navigateByUrl(
                  `/pacing-lesson-plan/view-lesson-plans/${
                    pacingPlanId ? pacingPlanId : this.currentShowPacingPlan[0].id
                  }/${this.viewDate.getTime()}/${this.classroom.id}/${true}`,
                )
              : this.router.navigateByUrl(
                  `/pacing-lesson-plan/view-lesson-plans/${
                    pacingPlanId ? pacingPlanId : this.currentShowPacingPlan[0].id
                  }/${this.viewDate.getTime()}/${this.classroom.id}`,
                );
          } else {
            this.loadingText = 'Please wait while generating lesson plan...';

            await this.getLessonPlanByAI(
              await this.setCurrentDateHoursAndMinutes(new Date(subjectHours[0].start)),
              await this.setCurrentDateHoursAndMinutes(new Date(subjectHours[0].end)),
              pacingPlanId,
              isCustomStandard,
            );

            this.loadingText = '';
            this.spinner.hide('pacingPlanDayViewSpinner');
          }
          this.pacingPlanService.view = 'Day';
          this.calendarService.viewDate = this.viewDate;
        } else {
          if (this.currentShowPacingPlan && this.currentShowPacingPlan.length === 1) {
            // to show the lesson plan with 1 standard
            const adminLessonPlan = await this.getAdminLessonPlan(pacingPlanId);
            if (adminLessonPlan && adminLessonPlan.length > 0 && adminLessonPlan[0] !== undefined) {
              this.emitFalseValueToDismissBottomSheet();
              this.storageService.setItem('currentValidDates', await this.getUpdatedDates());
              this.storageService.removeItem('lessonPlanIdType');
              typeOfLessonPlan = adminLessonPlan[0]['pacing_plan_id']
                ? 'pacing_plan_id'
                : adminLessonPlan[0]['teacher_custom_pacing_plans_id']
                  ? 'teacher_custom_pacing_plans_id'
                  : 'custom_global_pacing_plan_id';
              this.storageService.setItem('lessonPlanIdType', typeOfLessonPlan);
              pacingPlanId
                ? this.router.navigateByUrl(
                    `/pacing-lesson-plan/view-lesson-plans/${
                      pacingPlanId ? pacingPlanId : this.currentShowPacingPlan[0].id
                    }/${this.viewDate.getTime()}/${this.classroom.id}/${true}`,
                  )
                : this.router.navigateByUrl(
                    `/pacing-lesson-plan/view-lesson-plans/${
                      pacingPlanId ? pacingPlanId : this.currentShowPacingPlan[0].id
                    }/${this.viewDate.getTime()}/${this.classroom.id}`,
                  );
            } else {
              this.loadingText = 'Please wait while generating lesson plan...';

              await this.getLessonPlanByAI(
                await this.setCurrentDateHoursAndMinutes(new Date(subjectHours[0].start)),
                await this.setCurrentDateHoursAndMinutes(new Date(subjectHours[0].end)),
                pacingPlanId,
                isCustomStandard,
              );

              this.loadingText = '';
              this.spinner.hide('pacingPlanDayViewSpinner');
            }
            this.pacingPlanService.view = 'Day';
            this.calendarService.viewDate = this.viewDate;
          } else {
            // to generate lesson plan for multiple standards
            if (this.currentShowPacingPlan && this.currentShowPacingPlan.length > 1) {
              const pacingPlanIds = this.currentShowPacingPlan.map((plan) => plan.id);
              const adminLessonPlan = await this.getAdminLessonPlan(pacingPlanId ? pacingPlanId : pacingPlanIds);
              if (adminLessonPlan && adminLessonPlan.length > 0 && adminLessonPlan[0] !== undefined) {
                // if (response && response.id) {
                this.emitFalseValueToDismissBottomSheet();
                this.storageService.setItem('currentValidDates', await this.getUpdatedDates());
                this.storageService.removeItem('lessonPlanIdType');
                typeOfLessonPlan = adminLessonPlan[0]['pacing_plan_id']
                  ? 'pacing_plan_id'
                  : adminLessonPlan[0]['teacher_custom_pacing_plans_id']
                    ? 'teacher_custom_pacing_plans_id'
                    : 'custom_global_pacing_plan_id';
                this.storageService.setItem('lessonPlanIdType', typeOfLessonPlan);
                this.currentPacingPlanIdToPush !== 0
                  ? this.router.navigate([`/pacing-lesson-plan/add-lesson-plan/${true}`], {
                      queryParams: adminLessonPlan,
                    })
                  : this.router.navigateByUrl(
                      `/pacing-lesson-plan/view-lesson-plans/${
                        this.currentShowPacingPlan
                          .map((plan) => plan.id) // Extract IDs from the array
                          .join('_') // Concatenate them into a single string
                      }/${this.viewDate.getTime()}/${this.classroom.id}`,
                    );
              } else {
                this.loadingText = 'Please wait while generating lesson plan...';

                await this.getLessonPlanByAI(
                  await this.setCurrentDateHoursAndMinutes(new Date(subjectHours[0].start)),
                  await this.setCurrentDateHoursAndMinutes(new Date(subjectHours[0].end)),
                  pacingPlanId,
                  isCustomStandard,
                );

                this.loadingText = '';
                this.spinner.hide('pacingPlanDayViewSpinner');
              }
              this.pacingPlanService.view = 'Day';
              this.calendarService.viewDate = this.viewDate;
            } else {
              this.toasterService.showToast(
                `There is no pacing plan found for ${this.classroom?.subject} with grade ${this.classroom?.grades?.grade} on this day,
              `,
                'danger',
              );
            }
          }
        }
      } else {
        this.toasterService.showToast(
          `You have not added subject hours for ${this.classroom?.subject} with grade ${
            this.classroom?.grades?.grade
          } for ${this.utilService.getWeekDayString(this.viewDate.getDay())}`,
          'danger',
        );
      }
      this.spinner.hide('pacingPlanDayViewSpinner');
    } catch (error) {
      this.spinner.hide('pacingPlanDayViewSpinner');
      // console.log(error);
    }
  }

  async getAdminLessonPlan(pacingPlanId?: number | number[]) {
    try {
      const body = {
        pacing_plan_id: pacingPlanId ? pacingPlanId : this.currentShowPacingPlan[0].id,
      };
      if (this.sectionId?.isCustom && this.sectionId?.isCustom === true) {
        body['is_custom'] = true;
      } else {
        body['is_custom'] = false;
      }
      const pacingPlanArray = await this.lessonPlanService.fetchFilteredLessonPlans(
        body,
        pacingPlanId || this.currentShowPacingPlan[0].id,
      );

      return pacingPlanArray;
    } catch (error) {
      //console.error('Error in getAdminLessonPlan:', error);
    }
  }

  async setCurrentDateHoursAndMinutes(selectedDate: Date) {
    try {
      const date = this.viewDate.setHours(
        selectedDate.getHours(),
        selectedDate.getMinutes(),
        selectedDate.getSeconds(),
        selectedDate.getMilliseconds(),
      );
      return date;
    } catch (error) {
      // console.log(error);
    }
  }

  async openLessonPlanModal(event, lessonPlan) {
    try {
      this.analyticsService?.trackEvent('Lesson Plan Modal', 'Pacing Plan Day View');
      if (!event.target.hasAttribute('data-child')) {
        this.isNewAdd = false;
        this.currentLessonPlan = lessonPlan;
        this.dialogRef = this.dialogService.open(this.pushLessonPlanDialog, {
          dialogClass: 'dialogClass',
          closeOnBackdropClick: false,
        });
      }
    } catch (error) {
      // console.log(error);
    }
  }

  getSafeUrls(urls) {
    try {
      return urls.map((x) => {
        const newUrl = x.replace('watch?v=', 'embed/');
        x = this.sanitizer.bypassSecurityTrustResourceUrl(newUrl);
        return x;
      });
    } catch (error) {
      // console.log(error);
    }
  }

  async openEventLessonPlanModal(event, currentLessonPlan) {
    try {
      if (!event.target.hasAttribute('data-child')) {
        this.analyticsService?.trackEvent('View Lesson Plan', 'Pacing Plan Day View');
        if (!this.router.url.includes('teacher-calender')) {
          this.spinner.show('pacingPlanDayViewSpinner');
          this.isAdd = false;

          const user = this.storageService.getItem('user');

          if ((user && this.storageService.checkUserRole(user.user.role_id, 'admin')) || user.user.role_id === 19) {
            currentLessonPlan?.updates[7]?.video_urls?.length > 0
              ? (currentLessonPlan.updates[7].video_urls = this.getSafeUrls(currentLessonPlan?.updates[7]?.video_urls))
              : [];

            currentLessonPlan?.updates[6]?.lesson_plan_media_id > 0
              ? (currentLessonPlan.updates[6].lesson_plan_media_id = await this.lessonPlanService.getLessonPlanMedia(
                  currentLessonPlan?.updates[6]?.lesson_plan_media_id,
                ))
              : null;

            this.pacingPlanService.isStudentLessonPlan.emit({
              isShow: true,
              lessonPlan: currentLessonPlan,
            });
          } else {
            const lessonPlan = await this.lessonPlanService.getTeacherLessonPlanById(currentLessonPlan.id);
            lessonPlan['classroomId'] = this.classroom.id;
            lessonPlan['isAdd'] = false;
            lessonPlan['currentDate'] = this.viewDate.getTime();
            this.router.url.includes('dashboard')
              ? (lessonPlan['currentDashboardUserId'] = Number(this.activatedRoute.snapshot.paramMap.get('userId')))
              : null;
            this.closeModal();
            this.emitFalseValueToDismissBottomSheet();
            this.router.navigate([`/pacing-lesson-plan/update-lesson-plan/${false}`], { queryParams: lessonPlan });
          }
        }
      }
      this.spinner.hide('pacingPlanDayViewSpinner');
    } catch (error) {
      this.spinner.hide('pacingPlanDayViewSpinner');
      console.log(error);
    }
  }

  async openDeletePlanModal(dialog: TemplateRef<any>) {
    try {
      this.analyticsService?.trackEvent('Delete Lesson Plan Modal', 'Pacing Plan Day View');
      this.dialogRef = this.dialogService.open(dialog);
    } catch (error) {
      // console.log(error);
    }
  }

  async updateEvents(events) {
    try {
      return events.map((event) => {
        const lesson_plan = {
          objective: '',
          anticipatory_set: '',
          presentation: '',
          guided_practice_questions: '',
          homework_questions: '',
          closure: '',
          grade: '',
          subject: '',
          section_id: '',
          section_title: '',
        };

        if (!event?.lesson_plan) {
          event['lesson_plan'] = lesson_plan;
        }

        event.start = new Date(event.start);
        event.end = new Date(event.end);
        event.updates.map((updatedFields) => {
          if (updatedFields.hasOwnProperty('objective')) {
            event.lesson_plan_id !== 0
              ? (event.lesson_plan.objective = updatedFields.objective)
              : (lesson_plan.objective = updatedFields.objective);
          } else if (updatedFields.hasOwnProperty('anticipatory_set')) {
            event.lesson_plan_id !== 0
              ? (event.lesson_plan.anticipatory_set = updatedFields.anticipatory_set)
              : (lesson_plan.anticipatory_set = updatedFields.anticipatory_set);
          } else if (updatedFields.hasOwnProperty('presentation')) {
            event.lesson_plan_id !== 0
              ? (event.lesson_plan.presentation = updatedFields.presentation)
              : (lesson_plan.presentation = updatedFields.presentation);
          } else if (updatedFields.hasOwnProperty('guided_practice_questions')) {
            event.lesson_plan_id !== 0
              ? (event.lesson_plan.guided_practice_questions = updatedFields.guided_practice_questions)
              : (lesson_plan.guided_practice_questions = updatedFields.guided_practice_questions);
          } else if (updatedFields.hasOwnProperty('homework_questions')) {
            event.lesson_plan_id !== 0
              ? (event.lesson_plan.homework_questions = updatedFields.homework_questions)
              : (lesson_plan.homework_questions = updatedFields.homework_questions);
          } else if (updatedFields.hasOwnProperty('closure')) {
            event.lesson_plan_id !== 0
              ? (event.lesson_plan.closure = updatedFields.closure)
              : (lesson_plan.closure = updatedFields.closure);
          }

          if (event.lesson_plan_id === 0) {
            if (updatedFields.hasOwnProperty('grade')) {
              lesson_plan.grade = updatedFields.grade;
            } else if (updatedFields.hasOwnProperty('subject')) {
              lesson_plan.subject = updatedFields.subject;
            } else if (updatedFields.hasOwnProperty('section_id')) {
              lesson_plan.section_id = updatedFields.section_id;
            } else if (updatedFields.hasOwnProperty('section_title')) {
              lesson_plan.section_title = updatedFields.section_title;
            }
          }
        });

        event.lesson_plan_id === 0 ? Object.assign(event, { lesson_plan }) : null;
        return event;
      });
    } catch (error) {
      // console.log(error);
    }
  }

  async getLessonPlanByUserId() {
    try {
      this.lessonPlanEvents = [];
      const body = {
        user_id: this.classroom.user_id ? this.classroom.user_id : this.user.id,
        school_id: this.user.school_id,
        start_time: new Date(this.viewDate.setHours(0, 0, 0, 0)).getTime(),
        end_time: new Date(this.viewDate.setHours(23, 59, 59, 59)).getTime(),
        classroom_id: this.classroom?.id,
      };
      let response = await this.lessonPlanService.getTeacherLessonPlanByUserId(body);
      //lesson plans added for archived classroom should not display
      response = response.filter((item) => {
        return item.classroom_details.isArchive === 0;
      });
      return response;
    } catch (error) {
      // console.log(error.error.message);
    }
  }

  // Helper function to process the text
  processText(text, prefixToRemove) {
    if (prefixToRemove === '5.' || prefixToRemove === '4.' || prefixToRemove === '6.') {
      return text
        ? text
            .replace(/[\**]/g, '')
            .replace(prefixToRemove, '')
            .replace(/\n/g, '<br>')
            .replace(/(^|[^$])#+/g, '$1')
            .trim()
        : '';
    } else {
      return text
        ? text
            .replace(/[\\#\**]/g, '')
            .replace(prefixToRemove, '')
            .trim()
        : '';
    }
  }

  async getLessonPlanByAI(startTime, endTime, pacingPlanId, isCustomStandard?: boolean) {
    try {
      if (!this.utilService.checkIfTokenLimitExceededAndCreditsOut(this.userAccessAIToken, this.user)) {
        const subject: any = await this.subjectService.getSubjectByID(
          pacingPlanId
            ? isCustomStandard
              ? this.customSectionId.subject_id
              : this.sectionId?.subject_id
            : this.classroom.current_subject_id,
        );
        let sections = [];
        if (this.sectionId && this.sectionId !== undefined) {
          const base = `"${
            pacingPlanId
              ? isCustomStandard
                ? this.customSectionId.section_id
                : this.sectionId?.section_id
              : this.customSectionId.section_id
          } ${
            pacingPlanId
              ? isCustomStandard
                ? this.customSectionId.section_title
                : this.sectionId?.section_title
              : this.customSectionId.section_title
          }"`;
          sections.push(base);
        } else {
          sections = this.currentShowPacingPlan.map((plan) => {
            return `"${
              pacingPlanId
                ? isCustomStandard
                  ? this.customSectionId.section_id
                  : this.sectionId?.section_id
                : plan.section_id
            } ${
              pacingPlanId
                ? isCustomStandard
                  ? this.customSectionId.section_title
                  : this.sectionId?.section_title
                : plan.section_title
            }"`;
          });
        }

        const basePrompt = `Generate a lesson plan for ${this.classroom?.grades?.grade} grade ${subject.subject} standard `;
        const sectionList = sections.slice(0, 3).join(' and ');
        const prompt: any = `${basePrompt}${sectionList}. Include only:
    1. Objective
    2. Anticipatory Set
    3. Presentation (3-5 minute presentation)
    4. Guided Practice Questions (3 guided practice questions with their solutions)
    5. Homework Questions (5 example homework questions in list format without answers)
    6. Closure without adding extra information or texts.`;
        const openAIRes = await this.openAIService.openAIEncryptionAPICall(prompt);

        if (openAIRes && openAIRes.code === 200) {
          const splittedText = await this.getOpenAILessonPlan(openAIRes?.data?.content);
          await this.handleAITokenUsage(this.currentLocalStorageUser?.user, this.userAccessAIToken);
          this.storageService.removeItem('lessonPlanIdType');
          const typeOfLessonPlan = isCustomStandard ? 'teacher_custom_pacing_plans_id' : 'pacing_plan_id';
          this.storageService.setItem('lessonPlanIdType', typeOfLessonPlan);
          if (splittedText) {
            const lessonPlan = {
              start: new Date(startTime),
              end: new Date(endTime),
              objective: this.processText(splittedText.objective, '2.'),
              anticipatory_set: this.processText(splittedText.anticipatory_set, '3.'),
              presentation: this.processText(splittedText.presentation, '4.'),
              guided_practice_questions: this.processText(splittedText.guided_practice_questions, '5.'),
              homework_questions: this.processText(splittedText.homework_questions, '6.'),
              closure: this.processText(splittedText.closure, '7.'),
            };

            this.lessonPlanForm.patchValue({
              objective: lessonPlan.objective,
              anticipatory_set: lessonPlan.anticipatory_set,
              presentation: lessonPlan.presentation,
              guided_practice_questions: lessonPlan.guided_practice_questions,
              homework_questions: lessonPlan.homework_questions,
              closure: lessonPlan.closure,
              start: new Date(startTime),
              end: new Date(endTime),
            });

            this.currentPacingPlanIdToPush = pacingPlanId ? pacingPlanId : 0;
            // this.dialog.closeAll();

            this.dialogRef = this.dialogService.open(this.lessonPlanModal, {
              dialogClass: 'dialogClass',
              closeOnBackdropClick: false,
            });
          } else {
            this.toasterService.showToast(`Our AI plan is not working, please try again after some time`, 'danger');
          }
        } else {
          this.toasterService.showToast(`Our AI plan is not working, please try again after some time`, 'danger');
        }
      }
    } catch (error) {}
  }

  async addCurrentLessonPlanAndRender() {
    try {
      this.analyticsService?.trackEvent('Add Lesson Plan', 'Classroom Dashboard Lesson Plan');
      this.isLoading = true;
      if (this.dialogRef) {
        this.dialogRef.close();
      }
      // if (this.modalInstanceTwo) {
      //   this.modalInstanceTwo.hide();
      // }
      // this.modalService.dismissAll(this.lessonPlanModal);
      this.spinner.show('pacingPlanDayViewSpinner');
      this.modalService.dismissAll(this.lessonPlanModal);
      const lessonPlanToAdd = {
        start: this.lessonPlanForm.value.start,
        end: this.lessonPlanForm.value.end,
        objective: this.lessonPlanForm.value.objective,
        anticipatory_set: this.lessonPlanForm.value.anticipatory_set,
        presentation: this.lessonPlanForm.value.presentation,
        guided_practice_questions: this.lessonPlanForm.value.guided_practice_questions,
        homework_questions: this.lessonPlanForm.value.homework_questions,
        closure: this.lessonPlanForm.value.closure,
        subject_id: this.classroom.current_subject_id,
        video_urls: [],
        lesson_plan_media_id: null,
        school_id: this.user.school_id,
      };
      const pacingPlanIdArray = [];
      const teacherPacingPlanIdArray = [];
      const customGlobalPacingPlanIdArray = [];
      if (this.customSectionId && this.customSectionId !== undefined) {
        if (this.customSectionId?.is_teacher_custom_pacing_plan === false) {
          pacingPlanIdArray.push(
            this.currentPacingPlanIdToPush !== 0 ? this.currentPacingPlanIdToPush : this.customSectionId.id,
          );
          lessonPlanToAdd['pacing_plan_id'] = pacingPlanIdArray;
        }
        if (this.customSectionId?.is_teacher_custom_pacing_plan === true) {
          teacherPacingPlanIdArray.push(
            this.currentPacingPlanIdToPush !== 0 ? this.currentPacingPlanIdToPush : this.customSectionId.id,
          );
          lessonPlanToAdd['teacher_custom_pacing_plans_id'] = teacherPacingPlanIdArray;
        }
        if (this.customSectionId?.is_teacher_custom_pacing_plan === false) {
          customGlobalPacingPlanIdArray.push(
            this.currentPacingPlanIdToPush !== 0 ? this.currentPacingPlanIdToPush : this.customSectionId.id,
          );
          lessonPlanToAdd['custom_global_pacing_plan_id'] = customGlobalPacingPlanIdArray;
        }
      } else {
        if (this.sectionId && this.sectionId !== undefined) {
          if (
            this.sectionId?.is_teacher_custom_pacing_plan === false ||
            !this.sectionId?.is_teacher_custom_pacing_plan
          ) {
            pacingPlanIdArray.push(
              this.currentPacingPlanIdToPush !== 0 ? this.currentPacingPlanIdToPush : this.sectionId.id,
            );
            lessonPlanToAdd['pacing_plan_id'] = pacingPlanIdArray;
          }
          if (this.sectionId?.is_teacher_custom_pacing_plan === true) {
            teacherPacingPlanIdArray.push(
              this.currentPacingPlanIdToPush !== 0 ? this.currentPacingPlanIdToPush : this.sectionId.id,
            );
            lessonPlanToAdd['teacher_custom_pacing_plans_id'] = teacherPacingPlanIdArray;
          }
          if (this.sectionId?.is_teacher_custom_pacing_plan === false) {
            customGlobalPacingPlanIdArray.push(
              this.currentPacingPlanIdToPush !== 0 ? this.currentPacingPlanIdToPush : this.sectionId.id,
            );
            lessonPlanToAdd['custom_global_pacing_plan_id'] = customGlobalPacingPlanIdArray;
          }
        } else {
          for (let i = 0; i < this.currentShowPacingPlan.length; i++) {
            if (
              this.currentShowPacingPlan[i]?.is_teacher_custom_pacing_plan === false ||
              !this.currentShowPacingPlan[i]?.is_teacher_custom_pacing_plan
            ) {
              pacingPlanIdArray.push(
                this.currentPacingPlanIdToPush !== 0
                  ? this.currentPacingPlanIdToPush
                  : this.currentShowPacingPlan[i].id,
              );
              lessonPlanToAdd['pacing_plan_id'] = pacingPlanIdArray;
            }
            // else {
            if (this.currentShowPacingPlan[i]?.is_teacher_custom_pacing_plan === true) {
              teacherPacingPlanIdArray.push(
                this.currentPacingPlanIdToPush !== 0
                  ? this.currentPacingPlanIdToPush
                  : this.currentShowPacingPlan[i].id,
              );
              lessonPlanToAdd['teacher_custom_pacing_plans_id'] = teacherPacingPlanIdArray;
            }
            // else {
            //   customGlobalPacingPlanIdArray.push(
            //     this.currentPacingPlanIdToPush !== 0
            //       ? this.currentPacingPlanIdToPush
            //       : this.currentShowPacingPlan[i].id
            //   );
            //   lessonPlanToAdd['custom_global_pacing_plan_id'] =
            //     customGlobalPacingPlanIdArray;
            // }

            // if (this.addLessonPlanForm?.value?.standard_type === 'false') {
            //   lessonPlanToAdd['teacher_custom_pacing_plans_id'] =
            //     this.currentPacingPlanIdToPush !== 0
            //       ? this.currentPacingPlanIdToPush
            //       : this.currentShowPacingPlan[i].id;
            // }
          }
        }
      }
      const response = await this.lessonPlanService.addLessonPlan(lessonPlanToAdd);
      if (this.customSectionId && this.customSectionId?.id !== '') {
        const custom_global_pacing_plan = {
          section_id: this.customSectionId?.section_id,
          section_title: this.customSectionId?.section_title,
          subject_id: this.customSectionId?.subject_id,
          grades_id: this.customSectionId?.grades_id,
          user_id: this.sectionId?.user_id,
          classroom_id: this.classroom.id,
        };
        const data = await this.pacingPlanService.addCustomGlobalPacingPlan(custom_global_pacing_plan);

        // const body = {
        //   section_title: this.sectionId?.section_title,
        //   subject_id: this.sectionId?.subject_id,
        //   grades_id: this.sectionId?.grades_id,
        //   user_id: this.sectionId?.user_id,
        // };
        // await this.pacingPlanService.addCustomStandards(body);
        this.storageService.setItem('currentPushedLessonPlans', {
          pacing_plan_id: data?.id,
          pacingPlanEvents: this.pacingPlanEvents,
          reason: 'Reteach Standard of Custom Choice',
        });
      }

      if (response && response.id) {
        this.emitFalseValueToDismissBottomSheet();
        response['classroomId'] = this.classroom.id;
        response['currentDate'] = this.viewDate.getTime();
        response['pushLessonPlan'] = 'true';
        // if (this.currentPacingPlanIdToPush !== 0) {
        //   typeOfLessonPlan = response['pacing_plan_id']
        //     ? 'pacing_plan_id'
        //     : response['teacher_custom_pacing_plans_id']
        //     ? 'teacher_custom_pacing_plans_id'
        //     : 'custom_global_pacing_plan_id';
        // } else {
      }
      this.storageService.setItem('currentValidDates', await this.getUpdatedDates());
      this.currentPacingPlanIdToPush !== 0
        ? this.router.navigate([`/pacing-lesson-plan/add-lesson-plan/${true}`], {
            queryParams: response,
          })
        : this.router.navigateByUrl(
            `/pacing-lesson-plan/view-lesson-plans/${
              this.currentShowPacingPlan
                .map((plan) => plan.id) // Extract IDs from the array
                .join('_') // Concatenate them into a single string
            }/${this.viewDate.getTime()}/${this.classroom.id}`,
          );
      this.spinner.hide('pacingPlanDayViewSpinner');
    } catch (error) {
      this.spinner.hide('pacingPlanDayViewSpinner');
      console.log('addCurrentLessonPlanAndRender', error);
    }
  }

  async getOpenAILessonPlan(response: string) {
    try {
      response = response.replace(/---/g, '');

      const num = response.includes('Guided Practice Questions') ? 27 : 16;
      const homeWorkQNum = response.includes('Homework Questions') ? 19 : 9;

      const responseData = {
        objective: response.substring(response.indexOf('Objective') + 11, response.lastIndexOf('Anticipatory Set')),
        anticipatory_set: response.substring(
          response.indexOf('Anticipatory Set') + 18,
          response.lastIndexOf('Presentation'),
        ),
        presentation: response.substring(
          response.indexOf('Presentation') + 14,
          response.includes('Guided Practice Questions')
            ? response.lastIndexOf('Guided Practice Questions')
            : response.lastIndexOf('Guided Practice'),
        ),
        guided_practice_questions: response
          .substring(
            response.includes('Guided Practice Questions')
              ? response.indexOf('Guided Practice Questions')
              : response.indexOf('Guided Practice') + num,
            response.includes('Homework Questions')
              ? response.lastIndexOf('Homework Questions')
              : response.lastIndexOf('Homework'),
          )
          .replace('Guided Practice Questions:', '')
          .replace('Guided Practice:', '')
          .replace('5.', ''),
        closure: response.substring(response.indexOf('Closure') + 9, response.lastIndexOf('')),
        homework_questions: response.indexOf('Homework Questions')
          ? response
              .substring(
                response.includes('Homework Questions')
                  ? response.lastIndexOf('Homework Questions')
                  : response.lastIndexOf('Homework') + homeWorkQNum,
                response.lastIndexOf('Closure'),
              )
              .replace('Homework Questions:', '')
              .replace('Homework:', '')
          : '',
      };

      return responseData;
    } catch (error) {
      // console.log(error);
    }
  }

  async getEndDate(date: Date, hours: number) {
    try {
      const dateCopy = new Date(date.getTime());
      dateCopy.setTime(dateCopy.getTime() + hours * 60 * 60 * 1000);
      return dateCopy;
    } catch (error) {
      // console.log(error);
    }
  }

  async getSchoolCalendarBySchoolId() {
    try {
      this.currentCalendar = [];
      const params = {
        school_id: this.user.school_id,
      };
      return await this.calendarService.schoolCalendarBySchoolId(params);
    } catch (error) {
      // console.log(error);
    }
  }

  setView(event: string) {
    this.analyticsService?.trackEvent('Close Expand View', 'Pacing Plan Day View');
    this.newItemEvent.emit(event);
  }

  closeOpenMonthViewDay() {
    this.activeDayIsOpen = false;
  }

  closeModal(): void {
    try {
      // if (this.modalInstanceOne) {
      //   this.modalInstanceOne.hide();
      // }
      // this.modalService.dismissAll(this.myModal);
    } catch (error) {
      // console.log(error);
    }
  }

  async deleteLessonPlan() {
    try {
      this.analyticsService?.trackEvent('Delete Lesson Plan From Database', 'Pacing Plan Day View');
      this.spinner.show('pacingPlanDayViewSpinner');
      this.dialogRef.close();
      this.closeModal();
      await this.lessonPlanService.deleteTeacherLessonPlan(this.currentLessonPlan.id);
      await this.getLessonPlanEvents();

      this.spinner.hide('pacingPlanDayViewSpinner');
    } catch (error) {
      // console.log(error);
      this.spinner.hide('pacingPlanDayViewSpinner');
    }
  }

  async openSelectReasonDialog(lessonPlan?) {
    try {
      if (this.user.is_trial_user) {
        this.toasterService.showToast('You can push lesson plan from here', 'info');
        return;
      }
      this.analyticsService?.trackEvent('Push Lesson Plans', 'Pacing Plan Day View');

      this.currentLessonPlanToPush = lessonPlan;
      this.selectedPushLessonPlanEventReason = '';
      // this.currentGlobalPacingPlan = lessonPlan?.lesson_plan?.pacing_plan;
      // this.currentGlobalPacingPlan = lessonPlan?.lesson_plan?.pacing_plan_id.length > 0
      //   ? lessonPlan?.lesson_plan?.pacing_plan_id
      //   : lessonPlan?.lesson_plan?.teacher_custom_pacing_plans;

      this.currentGlobalPacingPlan = [
        ...(lessonPlan?.lesson_plan?.pacing_plan_id?.length > 0
          ? lessonPlan.lesson_plan.pacing_plan_id.filter((item) => item != null)
          : []),
        ...(lessonPlan?.lesson_plan?.teacher_custom_pacing_plans_id?.length > 0
          ? lessonPlan.lesson_plan.teacher_custom_pacing_plans_id.filter((item) => item != null)
          : []),
      ];

      this.dialogRef = this.dialogService.open(this.selectSubjectDialog, {});
    } catch (error) {
      console.log('openSelectReasonDialog', error);
    }
  }

  async closeDialogOfReason() {
    try {
      this.dialogRef.close();
    } catch (error) {
      // console.log(error);
    }
  }

  async getUpdatedPacingPlans() {
    try {
      await this.getGlobalPacingPlanCurrentPacingPLan(true);
      await this.getLessonPlanEvents();
    } catch (error) {}
  }

  async setDateToGlobalPacingEvents(pacingPlanEvents) {
    try {
      const filteredDates = this.dates.filter((x) => x.addEvent === true);
      return pacingPlanEvents.map((x, i) => {
        if (filteredDates[i]) {
          x.start = new Date(filteredDates[i].start);
          x.end = new Date(filteredDates[i].end);
          return x;
        }
      });
    } catch (error) {
      // console.log(error);
    }
  }

  back() {
    try {
      if (this.router.url.includes('classroom-details')) {
        this.isExpandModal
          ? this.pacingPlanService.isFirstView.emit(true)
          : this.pacingPlanService.isFirstView.emit(false);
      } else {
        this.router.navigate(['test-quizzes/classroom-details', this.classroom.id]);
      }

      this.pacingPlanService.isPushed.emit(this.isPush);
    } catch (error) {
      // console.log(error);
    }
  }

  async getTestAndReviewDays() {
    try {
      const date1 = dayjs(this.currentCalendar[0].start);
      const date2 = dayjs(this.currentCalendar[0].end);
      const diff = date2.diff(date1, 'day');

      const dates = [];
      this.testAndReviewDays = [];

      if (this.classroom.isManual) {
        this.databaseEvents?.custom_pacing_plans_test_review_days?.map((x: any) => {
          this.testAndReviewDays.push({
            start: new Date(x.start_date),
            end: new Date(x.end_date),
            isDay: true,
            type: x.day === 'test-day' ? 'Test Day' : 'Review Day',
          });

          return x;
        });
        return;
      }

      for (let i = 0; i < diff; i++) {
        const startDate: any = dayjs(new Date(this.currentCalendar[0].start))
          .year(new Date(this.currentCalendar[0].start).getFullYear())
          .add(i, 'day');
        const date: any = {
          start: dayjs(startDate, 'YYYY-MM-DD').tz().toDate(),
          end: dayjs(startDate.endOf('day'), 'YYYY-MM-DD').tz().toDate(),
          isDay:
            startDate.day() === 0 || startDate.day() === 6
              ? false
              : !this.events.find((event) => {
                    if (
                      startDate.startOf('day').valueOf() >= new Date(event.start).getTime() &&
                      startDate.startOf('day').valueOf() <= new Date(event.end).getTime()
                    ) {
                      return event;
                    }
                  })
                ? this.checkIfPresentInExtraEvents(startDate)
                : false,
        };
        if (date.isDay) {
          dates.push(date);
        }
      }

      const testDay = this.classroom?.test_day ? this.classroom?.test_day : this.user?.teachingInfo.examPerdays;

      let newIndex = testDay;

      const checkAlreadyDeletedEvents = await this.pacingPlanService.checkedAlreadyDeletedEvents({
        user_id: this.user?.id,
        subject_id: this.classroom.current_subject_id,
        classroom_id: this.classroom.id,
      });

      this.deletedDays = checkAlreadyDeletedEvents;

      this.deletedTestDays = checkAlreadyDeletedEvents.filter((event) => event.type === 'Test Day');

      this.deletedReviewDays = checkAlreadyDeletedEvents.filter((event) => event.type === 'Review Day');

      // dates.map((event) => {
      //   const testDayValues = dates[newIndex];

      //   const reviewDayValues = dates[newIndex + 1];

      //   if (testDayValues) {
      //     this.filterTestAndReviewDayData(this.deletedTestDays);
      //     this.testAndReviewDays.push({
      //       start: testDayValues.start,
      //       end: testDayValues.end,
      //       isDay: testDayValues.isDay,
      //       type: 'Test Day',
      //     });
      //     // }
      //   }

      //   if (reviewDayValues) {
      //     this.filterTestAndReviewDayData(this.deletedReviewDays);
      //     this.testAndReviewDays.push({
      //       start: reviewDayValues.start,
      //       end: reviewDayValues.end,
      //       isDay: reviewDayValues.isDay,
      //       type: 'Review Day',
      //     });
      //     // }}
      //   }

      //   newIndex = newIndex + (testDay + 2);
      //   return event;
      // });

      for (; newIndex < dates.length; ) {
        const testDayValues = dates[newIndex];
        const reviewDayValues = dates[newIndex + 1];

        if (testDayValues) {
          await this.filterTestAndReviewDayData(this.deletedTestDays);
          this.testAndReviewDays.push({
            start: testDayValues.start,
            end: testDayValues.end,
            isDay: testDayValues.isDay,
            type: 'Test Day',
          });
        }

        if (reviewDayValues) {
          await this.filterTestAndReviewDayData(this.deletedReviewDays);
          this.testAndReviewDays.push({
            start: reviewDayValues.start,
            end: reviewDayValues.end,
            isDay: reviewDayValues.isDay,
            type: 'Review Day',
          });
        }

        newIndex = newIndex + (testDay + 2); // assuming testDay is defined elsewhere
      }

      // this.dates = dates;
    } catch (error) {
      console.log('getTestAndReviewDay', error);
    }
  }

  async filterTestAndReviewDayData(deleteDayArray) {
    const deleteCriteria = deleteDayArray.map((item) => ({
      type: item.type,
      start: item.start,
    }));
    this.testAndReviewDays = this.testAndReviewDays.filter((item) => {
      return !deleteCriteria.some((delItem) => {
        return delItem.type === item.type && new Date(delItem.start).toString() === item.start.toString();
      });
    });
  }

  async ifDayIsTestOrReviewDay(date?: Date) {
    try {
      return date
        ? this.testAndReviewDays.filter((event) => event.start.toDateString() === new Date(date).toDateString())
        : this.testAndReviewDays.filter((event) => event.start.toDateString() === this.viewDate.toDateString());
    } catch (error) {
      // console.log(error);
    }
  }

  emitFalseValueToDismissBottomSheet() {
    this.pacingPlanService.isFirstView.emit(false);
  }

  ngOnDestroy(): void {
    this.pacingPlanService.view = 'Month';
  }

  async changeReason(event: any) {
    try {
      this.selectedPushLessonPlanEventReason = event;
      if (event !== 'Reteach Yesterday’s Standard') {
        this.dialogRef.close();
        // this.dialog.closeAll();
        this.currentLessonPlan = null;

        this.isNewAdd = true;
        // this.myModal ? this.modalService.dismissAll(this.myModal) : null;
        this.dialogRef = this.dialogService.open(this.pushLessonPlanDialog, {
          dialogClass: 'dialogClass',
          closeOnBackdropClick: false,
        });
      }
    } catch (error) {
      // this.spinner.hide();
      // console.log(error);
    }
  }

  checkIfPreviousDayHavingStandard() {
    try {
      const currentValidDate = this.dates
        .filter(
          (x) =>
            x.addEvent === true &&
            new Date(x.start).setHours(0, 0, 0, 0) < new Date(this.viewDate).setHours(0, 0, 0, 0),
        )
        .sort((a, b) => new Date(b.start).setHours(0, 0, 0, 0) - new Date(a.start).setHours(0, 0, 0, 0))[0];

      if (currentValidDate) {
        const events = this.pacingPlanEvents.filter(
          (x: any) => new Date(x.start).toDateString() === new Date(currentValidDate.start).toDateString(),
        );

        if (events?.length > 0) {
          return true;
        }
      }

      return false;
    } catch (error) {
      // console.log(error);
    }
  }

  async pushDateToNext() {
    try {
      if (this.selectedPushLessonPlanEventReason) {
        const available = this.checkIfPreviousDayHavingStandard();

        if (!available) {
          this.toasterService.showToast('There is no standard found for previous day', 'danger');
          return true;
        }
      }
      this.analyticsService?.trackEvent('Push Lesson Plan', 'Pacing Plan Day View');
      this.spinner.show('pacingPlanDayViewSpinner');
      this.isPush = true;

      this.dialogRef.close();

      const body = {
        start: this.viewDate.setHours(0, 0, 0, 0),
        end: this.viewDate.setHours(23, 59, 59, 59),
        user_id: this.user.id,
        subject_id: this.currentGlobalPacingPlan[0].subject_id,
        grades_id: this.currentGlobalPacingPlan[0].grades_id,
        reason: this.selectedPushLessonPlanEventReason,
        classroom_id: this.classroom.id,
      };

      if (
        this.currentGlobalPacingPlan[0]?.section_id !== '' &&
        this.currentGlobalPacingPlan[0]?.section_id !== undefined
      ) {
        body['global_pacing_plan_id'] = this.currentGlobalPacingPlan[0].id;
      } else {
        body['teacher_custom_pacing_plans_id'] = this.currentGlobalPacingPlan[0].id;
      }

      const response = await this.pacingPlanService.addTeacherPacingPlan(body);

      if (response && response.id) {
        await this.updateMultipleTeacherLessonPlans();
        await this.getUpdatedPacingPlans();
      }

      // for (const pacingPlan of this.currentGlobalPacingPlan) {

      // }

      this.currentGlobalPacingPlan = [];

      this.spinner.hide('pacingPlanDayViewSpinner');
    } catch (error) {
      console.error('Error in pushDateToNext:', error);
      this.spinner.hide('pacingPlanDayViewSpinner');
    }
  }

  async updateMultipleTeacherLessonPlans() {
    try {
      const lessonPlansToPush = [];

      const allLessonPlanEvents: any = await this.getAllLessonPlanEvents(
        this.currentLessonPlanToPush?.subject_id,
        this.currentLessonPlanToPush?.grades_id,
      );

      const dates = await this.getUpdatedDates();

      for (const iterator of allLessonPlanEvents) {
        const currentIndex = dates.findIndex(
          (x) => new Date(x.start).toDateString() === new Date(iterator.start).toDateString(),
        );
        const currentPlan = dates[currentIndex + 1];

        let iteratorStartTime, iteratorEndTime;
        if (this.classroom.extras['eventDates'].length > 0) {
          const allottedTime = this.teacherLessonPlanService.getTeacherPeriodsFromEvents(
            this.classroom,
            currentPlan,
            this.currentLessonPlanToPush,
            iterator,
          );
          iteratorStartTime = allottedTime.iteratorStartTime;
          iteratorEndTime = allottedTime.iteratorEndTime;
        }
        const newStart = new Date(currentPlan.start).toDateString() + ' ' + iteratorStartTime;
        const newEnd = new Date(currentPlan.end).toDateString() + ' ' + iteratorEndTime;

        const body = {
          start: new Date(newStart),
          end: new Date(newEnd),
          user_id: iterator.user_id,
          school_id: iterator.school_id,
          lesson_plan_id: iterator.lesson_plan.id,
          updates: iterator.updates,
          id: iterator.id,
          classroom_id: this.classroom.id,
        };
        lessonPlansToPush.push(body);
      }

      if (lessonPlansToPush.length > 0) {
        const updatedLessonPlanBody = {
          teacher_lesson_plan: lessonPlansToPush,
        };

        await this.lessonPlanService.updateMultipleLessonPlanEvents(updatedLessonPlanBody);
      }
    } catch (error) {
      console.log('updateMultipleTeacherLessonPlans', error);
    }
  }

  async getTeacherLessonPlanByAI(sectionTitle?: any) {
    try {
      this.isLoading = true;
      if (this.dialogRef) {
        this.dialogRef.close();
      }
      // this.modalService.dismissAll(this.myModal);
      this.spinner.show('pacingPlanDayViewSpinner');
      this.modalService.dismissAll(this.myModal);
      if (sectionTitle) {
        const body = {
          section_title: sectionTitle,
          subject_id: this.classroom?.current_subject_id,
          grades_id: this.classroom.grades_id,
          user_id: this.user.id,
        };

        this.customSectionId = await this.pacingPlanService.addCustomStandards(body);
        await this.lessonPlanEventClicked(this.customSectionId?.id, true, false);

        this.storageService.setItem('currentPushedLessonPlans', {
          pacing_plan_id: this.currentShowPacingPlan[0]?.id,
          pacingPlanEvents: this.pacingPlanEvents,
        });

        this.storageService.setItem('getUpdatedDates', await this.getUpdatedDates());
      } else {
        if (this.sectionId?.section_id === '' || this.sectionId?.section_id === undefined) {
          this.sectionId['isCustom'] = true;
        }

        this.storageService.setItem('currentPushedLessonPlans', {
          pacing_plan_id: this.currentShowPacingPlan[0]?.id,
          pacingPlanEvents: this.pacingPlanEvents,
        });
        await this.lessonPlanEventClicked(this.sectionId?.id, false, false);
      }

      this.spinner.hide('pacingPlanDayViewSpinner');
      this.spinnerText = '';
    } catch (error) {
      this.spinner.hide('pacingPlanDayViewSpinner');
      // console.log(error);
    }
  }

  async addTeacherLessonPlanAndPush() {
    try {
      this.spinner.show('pacingPlanDayViewSpinner');
      const body = await this.getTeacherLessonPlanBody();
      const response = await this.lessonPlanService.addTeacherLessonPlan(body);

      if (response && response.id) {
        this.closeModal();
        await this.pushDateToNext();
      }
      this.spinner.hide('pacingPlanDayViewSpinner');
    } catch (error) {
      this.spinner.hide('pacingPlanDayViewSpinner');
      // console.log(error);
    }
  }

  async getTeacherLessonPlanBody() {
    try {
      const subjHoursBody = {
        user_id: this.user.id,
        subject_id: this.classroom.current_subject_id,
        grade_id: this.classroom.grades_id,
        day: this.utilService.getWeekDayString(new Date(this.currentShowPacingPlan[0].start).getDay()).toLowerCase(),
      };
      if (this.user?.teachingInfo?.schoolBellScheduleId)
        subjHoursBody['school_bell_shedules_id'] = this.user?.teachingInfo?.schoolBellScheduleId;
      const subjHours: any = await this.teacherLessonPlanService.getTeacherSubjectHours(subjHoursBody);
      const startDt = await this.setCurrentDateHoursAndMinutes(new Date(subjHours[0].start));
      const endDt = await this.setCurrentDateHoursAndMinutes(new Date(subjHours[0].end));
      const id = this.pacingPlanEvents.findIndex((x: any) => x.id === this.currentShowPacingPlan[0].id);
      const prevPlan = this.pacingPlanEvents[id - 1];
      const newUpdates = [
        { objective: this.currentLessonPlan.objective },
        { anticipatory_set: this.currentLessonPlan.anticipatory_set },
        { presentation: this.currentLessonPlan.presentation },
        {
          guided_practice_questions: this.currentLessonPlan.guided_practice_questions,
        },
        { homework_questions: this.currentLessonPlan.homework_questions },
        { closure: this.currentLessonPlan.closure },
        { section_id: prevPlan.section_id },
        { section_title: prevPlan.section_title },
        { grade: this.classroom.grades.grade },
        { subject: this.classroom.subject.subject },
      ];

      const teacherLessonPlan = {
        start: new Date(startDt),
        end: new Date(endDt),
        user_id: this.user.id,
        school_id: this.user.school_id,
        lesson_plan_id: null,
        updates: newUpdates,
        classroom_id: this.classroom.id,
      };

      return teacherLessonPlan;
    } catch (error) {
      // console.log(error);
    }
  }
  // token_used table functions
  // async getUserToken() {
  //   try {
  //     // restrict openAI calls

  //     this.userAccessToken = await this.utilService.getUserToken(this.user);
  //     this.currentLocalStorageUser = this.storageService.getItem('user');
  //   } catch (error) {
  //     console.log('PacingPlanDayViewComponent getUser', error);
  //   }
  // }
  // async updateTokenUsed() {
  //   try {
  //     // restrict openAI calls
  //     await this.utilService.updateTokenUsed(this.currentLocalStorageUser.user, this.userAccessToken);

  //     await this.getUserToken();
  //   } catch (error) {
  //     console.log('PacingPlanDayViewComponent updateTokenUsed', error);
  //   }
  // }

  async onTextAreaChange() {
    this.standard = this.standard.replace(/\s+/g, ' ');
    this.standard = this.standard.trim();
  }

  checkIfPresentInExtraEvents(startDate: any) {
    if (this.classroom?.extras?.eventDates?.length === 0 || this.classroom?.subject_id?.length > 1) {
      // teacher only users
      if (this.isTeacherOnly) {
        return this.checkIfDateIsPresentInSubjectHoursData(startDate.format('dddd'));
      } else {
        // for multi subject classroom
        if (this.classroom.createdDuringTeacherOnly) {
          return this.checkIfDateIsPresentInSubjectHoursData(startDate.format('dddd'));
        } else {
          if (this.classroom?.extras?.eventDates?.length === 0) {
            const filteredData = this.subjectHoursData.find(
              (x) =>
                x.day.toLowerCase() === startDate.format('dddd').toLowerCase() &&
                x.subject_id === this.classroom.current_subject_id &&
                x.grades_id === this.classroom.grades_id,
            )
              ? true
              : false;
            return filteredData;
          } else {
            return this.checkIfDateIsPresentInSubjectHoursData(startDate.format('dddd'));
          }
        }
      }
    }
    return this.checkIfDateisPresentInSubjectHours(startDate.format('dddd'));
  }

  checkIfDateisPresentInSubjectHours(dayString: string) {
    if (this.classroom?.extras?.eventDates?.length > 0) {
      return this.classroom?.extras?.eventDates.find((x) => x.day.toLowerCase() === dayString.toLowerCase())
        ? true
        : false;
    }
    return false;
  }

  /**
   * @description Method is used to check if the day is in the schedule for teacher only users
   * @param dayString
   * @returns boolean
   */
  checkIfDateIsPresentInSubjectHoursData(dayString: string): boolean {
    if (this.classroom?.extras?.eventDates?.length > 0) {
      return this.classroom?.extras?.eventDates.find((x) => {
        return (
          x.day.toLowerCase() === dayString.toLowerCase() &&
          (x.subjectId ?? x.subject_id) === this.classroom.current_subject_id
        );
      })
        ? true
        : false;
    }
    return false;
  }

  /**
   * @description Method is used to get subject hours data for the particular user
   * @param void
   * @returns Promise<void>
   */
  private async getSubjectHoursData(): Promise<void> {
    const subjectHoursBody = {
      user_id: this.classroom.user_id ? this.classroom.user_id : this.user.id,
      subject_id: this.classroom.current_subject_id,
      grade_id: this.classroom.grades_id,
      day: this.utilService.getWeekDayString(this.viewDate.getDay()).toLowerCase(),
    };
    if (this.user?.teachingInfo?.schoolBellScheduleId && this.classroom.user_id === this.user.id)
      subjectHoursBody['school_bell_shedules_id'] = this.user?.teachingInfo?.schoolBellScheduleId;

    if (this.user.is_trial_user) {
      // Set the dummy teacher ID to fetch the subject hours
      subjectHoursBody['user_id'] = this.user?.teachingInfo?.dummyUserId ?? DummyUserIds.TEACHER;
    }
    this.subjectHoursData = await this.teacherLessonPlanService.getTeacherSubjectHoursByUserId(subjectHoursBody);
  }

  getFormattedAnswer(formControl: string): string {
    const answerValue = this.lessonPlanForm.get(formControl)?.value;
    if (!answerValue) return '';

    // Ensure answerValue is a string
    const answerText =
      typeof answerValue === 'string'
        ? answerValue
        : Array.isArray(answerValue)
          ? answerValue[0]
          : JSON.stringify(answerValue);

    // Remove unnecessary LaTeX syntax (backslashes and math expressions)
    return answerText
      .replace(/\*\*/g, '')
      .replace(/\n/g, '<br>')
      .replace(/^<br>/, '')
      .replace(/<br>$/, '')
      .replace(/\$/g, '\\$')
      .trim();
  }

  //AI credit Tokens
  async getUserAIToken() {
    try {
      // restrict openAI calls
      this.userAccessAIToken = await this.utilService.getUserAITokens(this.user?.id);
      this.currentLocalStorageUser = this.storageService.getItem('user');
    } catch (error) {
      // console.log('LessonPlanComponent getUserToken', error);
    }
  }

  async updateAITokenUsed() {
    try {
      // restrict openAI calls
      await this.utilService.updateUserAITokens(this.currentLocalStorageUser?.user.id, this.userAccessAIToken);

      await this.getUserAIToken();
    } catch (error) {
      // console.log('LessonPlanComponent updateTokenUsed', error);
    }
  }

  /**
   * @description Checks if a user's AI token usage should be incremented and updates it if needed.
   * Ensures that AI usage is properly counted for teachers, trial users, and users with restricted access.
   * @param user - Object containing user information (role, trial status, school limitations)
   * @param userAccessAIToken - Object containing AI token data (unlimited flag, tokens used, etc.)
   * @returns {Promise<boolean>} - Returns true if the token was updated, otherwise false
   */
  async handleAITokenUsage(user: any, userAccessAIToken: any): Promise<boolean> {
    // Convert the is_unlimited flag to string and check if the user has unlimited AI access
    const isUnlimited = String(userAccessAIToken?.is_unlimited) === 'true';
    if (isUnlimited) return false; // No token update needed for unlimited users
    // Check the user's role: teacher or teacher-only
    const isTeacher = this.storageService.checkUserRole(user?.role_id, UserRoles.Teacher);
    const isTeacherOnly = this.storageService.checkUserRole(user?.role_id, UserRoles.TeacherOnly);
    // Check if the user is a trial user
    const isTrialUser = Boolean(user?.is_trial_user);
    // Determine if the user has limited access based on their school's limitations
    // Safe fallback: if the second limitation is undefined, check the first one
    const limitedAccess =
      String(
        user?.school?.user_limitations?.[1]?.isLimitedAccess ?? user?.school?.user_limitations?.[0]?.isLimitedAccess,
      ) === 'true';
    // Only increment token usage if one of the following is true:
    // - Teacher with limited access
    // - Teacher-only user
    // - Trial user
    if ((isTeacher && limitedAccess) || isTeacherOnly || isTrialUser) {
      // Call the function to update the token count in the database
      await this.updateAITokenUsed();
      return true; // Indicate that the token was updated
    }

    // Token was not updated for this user
    return false;
  }

  /**
   * This function is designed as part of the push lesson plan functionality according to the academic year.
   * Moves the selected school calendar to the first position in the currentCalendar array.
   * @param {any} selectedSchoolCalendar - The school calendar object that should be moved to the first position in the array.
   * @returns {Promise<void>} A promise that resolves once the calendar has been moved to the first position.
   *
   */
  async setSelectedCalendarToFirst(selectedSchoolCalendar: any) {
    try {
      const index = this.currentCalendar.findIndex((calendar) => calendar.id === selectedSchoolCalendar.id);

      if (index !== -1 && index !== 0) {
        const [calendarToMove] = this.currentCalendar.splice(index, 1);
        this.currentCalendar.unshift(calendarToMove);
      }
    } catch (error) {
      console.log('setSelectedCalendarToFirst error', error);
    }
  }
}
